import * as constants from './constants';

export function setShowLocationModal(data) {
  return { type: constants.SET_SHOW_MODAL, payload: data };
}
